module.exports = __webpack_public_path__ + "Roboto-BoldItalic.4b2cc52b05e2a960c4f1.eot";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BoldItalic.eot
// module chunks = 34